import React from 'react';
import CommunityPartnerForm from '../components/CommunityPartnerForm';

const CommunityPartnerPage = () => {
  return (
    <div className="community-partner-page">
      <CommunityPartnerForm />
    </div>
  );
};

export default CommunityPartnerPage;
